/* Shared "Have us install / Install it yourself" mode for the Process page.
   Sections style themselves from html[data-install-mode]; #full-service and #self-install deep-link. */
if (!window.SokInstallMode) {
  window.SokInstallMode = {
    set(mode, { updateHash = true } = {}) {
      const root = document.documentElement;
      if (root.dataset.installMode === mode) return;
      root.classList.add('sok-mode-switching');
      clearTimeout(this.timer);
      // Fade out, swap, fade in (220ms, as in the design).
      this.timer = setTimeout(() => {
        root.dataset.installMode = mode;
        root.classList.remove('sok-mode-switching');
        document.dispatchEvent(new CustomEvent('sok:install-mode', { detail: { mode } }));
      }, 220);
      document.querySelectorAll('[data-install-toggle]').forEach((t) => t.classList.toggle('is-self', mode === 'self'));
      document.querySelectorAll('[data-install-set]').forEach((b) => b.setAttribute('aria-selected', String(b.dataset.installSet === mode)));
      if (updateHash) {
        try {
          history.replaceState(null, '', mode === 'self' ? '#self-install' : '#full-service');
        } catch (e) {}
      }
    },
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-install-set]');
    if (button) window.SokInstallMode.set(button.dataset.installSet);
  });
}
